import { useMemo } from 'react';
import { useTable } from 'spacetimedb/react';
import { tables as minetwinTables } from '@sdk/minetwin';

/**
 * Subscribed `visible_orientation_steps` rows + a `Map<stepId, row>` for
 * O(1) lookups. Review Queue joins step metrics back to this view to read
 * `durationMinutes` for the rushed-flag math.
 *
 * Map result is memoized on row identity, so it's safe to use as a dep in
 * downstream `useMemo` calls.
 */
export function useOrientationSteps() {
  const [rows, isReady] = useTable(
    'minetwin',
    minetwinTables.visible_orientation_steps,
  );

  const byStepId = useMemo(() => {
    const m = new Map<string, (typeof rows)[number]>();
    for (const r of rows) m.set(r.stepId, r);
    return m;
  }, [rows]);

  return { rows, byStepId, isReady };
}
